import { useEffect, useState } from "react";
import { useGetStudiesQuery } from "../api/studiesAPI";

export const useAvailableStudies = () => {
    const [studies, setStudies] = useState<string[]>([]);
    const {data, error, isLoading } = useGetStudiesQuery();
    
    useEffect(()=>{
        if(isLoading) {
            return;
        }
        if(error) {
            console.log('getStudies error', error);
        } else {
            if(data) {
                const studies = data.studies.map(study=> study.key);
                setStudies(studies);
            }
        }
    }, [isLoading, data, error]);
    return studies;
};